import { render, staticRenderFns } from "./ContratosPorGestor.vue?vue&type=template&id=9b7042c6"
import script from "./ContratosPorGestor.vue?vue&type=script&lang=js"
export * from "./ContratosPorGestor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports